import { GRANT_FINDER_INTERNATIONAL_SCOPE, GRANT_FINDER_NATIONWIDE_SCOPES } from "@simplyk/common";

export type UnlistedStatesReach = "nationwide" | "international" | "unspecified";

export const getUnlistedStatesReach = (geographyScope: string | null): UnlistedStatesReach => {
  if (geographyScope !== null && GRANT_FINDER_NATIONWIDE_SCOPES.includes(geographyScope)) {
    return "nationwide";
  }
  if (geographyScope === GRANT_FINDER_INTERNATIONAL_SCOPE) {
    return "international";
  }
  return "unspecified";
};
